import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Technology_Services from '@/views/Technology_Services'
import Big_Data from '@/views/Big_Data'
import About_Us from '@/views/About_Us'
import Contact_Us from '@/views/Contact_Us'

import mHome from '@/views/Mobile/Home'
import mTechnology_Services from '@/views/Mobile/Technology_Services'
import mBig_Data from '@/views/Mobile/Big_Data'
import mAbout_Us from '@/views/Mobile/About_Us'
import mContact_Us from '@/views/Mobile/Contact_Us'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '',
      redirect: '/Home'
    },
    {
      path: '/Home',
      name: 'Home',
      component: Home
    },
    {
      path: '/Technology_Services',
      name: 'Technology_Services',
      component: Technology_Services
    },
    {
      path: '/Big_Data',
      name: 'Big_Data',
      component: Big_Data
    },
    {
      path: '/About_Us',
      name: 'About_Us',
      component: About_Us
    },
    {
      path: '/Contact_Us',
      name: 'Contact_Us',
      component: Contact_Us
    },

    {
      path: '/mHome',
      name: 'mHome',
      component: mHome
    },
    {
      path: '/mTechnology_Services',
      name: 'mTechnology_Services',
      component: mTechnology_Services
    },
    {
      path: '/mBig_Data',
      name: 'mBig_Data',
      component: mBig_Data
    },
    {
      path: '/mAbout_Us',
      name: 'mAbout_Us',
      component: mAbout_Us
    },
    {
      path: '/mContact_Us',
      name: 'mContact_Us',
      component: mContact_Us
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js